import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import React, { Component } from "react";
import { Jumbotron, Container } from "reactstrap";
import { Animated } from "react-animated-css";
import "../../App.css";
class DealofTheMonth extends Component {
  render() {
    return (
      <div>
        <Container>
          <Animated
            animationInDelay="{100}"
            animationIn="bounceInLeft"
            animationOut="bounceInRight"
            isVisible
          >
            <Jumbotron>
              <div className="h1 ta-c p-h200 t--intro">Deals Of The Month</div>
              <br />
              <div className="ta-c p-h200 t--intro">$8 cheesecake slices </div>
              <br />
              <div className="ta-c p-h200 t--intro"> Five stuffed churros for $10</div>
              <br />
              <div className="ta-c p-h200 t--intro">$8 churro cups</div>
            </Jumbotron>
          </Animated>
        </Container>
      </div>
    );
  }
}
export default DealofTheMonth;
